// Port of api/fuel/app/classes/insights/ratings/publisher.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import Publisher from 'offline/model/publisher'

export default Segment.extend({
    name: 'publisher',
    priority: 1,
    default_: false,
    requires: [],
    insight: false,
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        var self = this

        var ratings = Util.query('\
            SELECT \
                r.game_id AS game, \
                AVG(r.rating_value) AS rating, \
                COUNT(r.rating_id) AS ratings \
            FROM \
                ( \
                    game_publisher l \
                    JOIN \
                    rating r \
                    ON \
                    r.game_id = l.game_id \
                    AND \
                    r.user_id IN (' + Util.in(userIndex) + ') \
                    AND \
                    l.publisher_id = ' + vars.id + ' \
                    AND \
                    l.game_version_id = 0 \
                ) \
                JOIN \
                game g \
                ON \
                r.game_id = g.game_id \
                AND \
                g.game_type = 1 \
                AND \
                l.game_publisher_primary = 1 \
            GROUP BY \
                g.game_id \
            ORDER BY \
                g.game_name ASC \
        ')

        var games = []

        for (var i = 0; i < ratings.length; i++) {
            var rating = ratings[i]

            self._references.games.push(parseInt(rating.game, 10))

            games.push({
                id: parseInt(rating.game, 10),
                count: (type === Constants.TYPE_USER) ? false : parseFloat(rating.ratings),
                rating: Math.round(parseFloat(rating.rating) * 10) / 10
            })
        }

        var publisher = Publisher.with_id(vars.id)

        return {
            publisher: publisher.get_name(),
            games: games
        }

    }
})
